export const generateExecutionKey = (pluginConfig: any): string => {
  return `${pluginConfig?.plugin_api_name}-${pluginConfig?.id}-${pluginConfig?.api_name}-${pluginConfig?.script_id}`;
};
